import { render } from "./ClientRolePropertiesDialog.vue?vue&type=template&id=ec37b020&scoped=true"
import script from "./ClientRolePropertiesDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientRolePropertiesDialog.vue?vue&type=script&setup=true&lang=js"

import "./ClientRolePropertiesDialog.vue?vue&type=style&index=0&id=ec37b020&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec37b020"],['__file',"src/components/dialogs/ClientRolePropertiesDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ec37b020"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ec37b020', __exports__)) {
    api.reload('ec37b020', __exports__)
  }
  
  module.hot.accept("./ClientRolePropertiesDialog.vue?vue&type=template&id=ec37b020&scoped=true", () => {
    api.rerender('ec37b020', render)
  })

}


export default __exports__